define('SageDotCom/Utility/LazyLoad',["jquery", "eventManager", "SageDotCom/Utility/sageMatchHeight", "SageDotCom/PolyFills/closest"
], function ($, eventManager, SageMatchHeight) {
    function LazyLoad() {
        eventManager.subscribe("invoke-lazy-load", this.setupObservers, this);
        eventManager.subscribe("add-aria-labels-to-pagination", this.setupObservers, this);
        eventManager.subscribe("lazy-animate-element", function ($scope) {
            this.observeAnimationsForScope($scope);
        }, this);
        this.setupObservers(); // go ahead and invoke on page load
    }

    // query elements which participates in lazyload
    LazyLoad.prototype.queryLazyElements = function queryLazyElements() {
        return document.querySelectorAll('.lazy');
    }

    LazyLoad.prototype.queryAnimatedElements = function queryAnimatedElements($scope) {
        var motionSelectorsArray = [
            '.vertical-tabset .nav-tabs-wrapper-inner',
            '.vertical-tabAccordion .nav-tabs-wrapper-inner',
            '.vertical-tabset .tab-content-wrapper-outer',
            '.vertical-tabAccordion .tab-content-wrapper-outer',
            '.container.fixed-grid > *',
            '.image-array-placeholder > img',
            '.image-array-flexible > img',
            '.image-array > img',
            '.score-flex-box > .flex-item',
            '.right.carousel-control',
            '.left.carousel-control',
            '.carousel-indicators',
            '.carousel-inner .item:first-of-type',
            '.score-flex-box > .flex-item',
            '.slick-slider',
            '.slick-slider .slick-slide',
            '.slick-active',
            '.slick-arrow',
            '.slick-dots',
            '.carousel-inner .item:first-of-type',
            '.carousel-inner .item.to-animate',
            '.slide-up-fast',
            '.slide-up-normal',
            '.slide-down-fast',
            '.slide-down-normal',
            '.slide-left-fast',
            '.slide-left-normal',
            '.slide-left-slow',
            '.slide-right-fast',
            '.slide-right-normal',
            '.slide-right-slow',
            '.fade-in-fast',
            '.fade-in-normal',
            '.rotate-fast',
            '.rotate-normal',
            '.rotate-slow'
        ];
        var motionSelectors = motionSelectorsArray.join(", ");
        return $scope.find(motionSelectors);
    }

    LazyLoad.prototype.observeAnimationsForScope = function ($scope) {
        if (!$("body").hasClass("animations-off")) {
            //special class for complications
            $scope.find('.carousel-inner .item:first-of-type').addClass("to-animate");
           
            if (!this.lazyLoadAnimationObserver) {
                var animationOptions = {
                    rootMargin: '0px 0px -40px 0px'
                };
                this.lazyLoadAnimationObserver = new IntersectionObserver(this.animationCallback.bind(this), animationOptions);
            }

            // query elements which should be lazyloaded
            var lazyAnimatedElements = this.queryAnimatedElements($scope);
            [].forEach.call(lazyAnimatedElements, function (elem) {

                this.lazyLoadAnimationObserver.observe(elem);
            }, this /* preserve current context */);
        }
    }

    LazyLoad.prototype.setupObservers = function () {
        // modern browsers way to check intersection of an object to load it at the right time
        if ("IntersectionObserver" in window) {
            // if observer is not created - create.
            // other option to come here from eventManager events, which are executed during page lifetime. 
            //added root margin to take the header into account so that homepage tabs images are loaded on time
            const rootMarginOptions = {
                rootMargin: "0px 0px 50px 0px"
            };
            if (!this.lazyLoadObserver) this.lazyLoadObserver = new IntersectionObserver(this.intersectionCheck.bind(this), rootMarginOptions);

            // query elements which should be lazyloaded
            const lazyElements = this.queryLazyElements();

            //immediately load the first image of the carousel
            const firstCarouselImg = document.querySelector(".carousel-inner .item:first-child img[data-src]");
            if (firstCarouselImg) {
                this.loadElement(firstCarouselImg);
            }

            const spacerImages = document.querySelectorAll('img.lazy[data-src*="/spacer-images/"]');
            var self = this;
            [].forEach.call(spacerImages, function (el) {
                self.loadElement(el);
            }); 

            //treat the next images, excluding the first one
            if (lazyElements && lazyElements.length > 0) {
                lazyElements.forEach(elem => {
                    if (elem.parentElement &&
                        elem.parentElement.classList &&
                        elem.parentElement.classList.contains("sage-product-card-compatible-os-icon")
                    ) {
                        // need to load these as it causes issues with match height in product cards on small screens
                        this.loadElement(elem);
                    } else {
                        this.lazyLoadObserver.observe(elem);
                    }
                });
            }

            if (!$("body").hasClass("animations-off")) {
                $("header, footer").addClass("animations-off");

                this.observeAnimationsForScope($("body:not(.animations-off)"));
            }
        }
    }

    LazyLoad.prototype.intersectionCheck = function (entities, observer) {
        var entitiesPrms = entities.map(function (intersectionEntity) {
            if (!intersectionEntity.isIntersecting) return Promise.resolve(null);

            var elem = intersectionEntity.target;
            
            if (elem.getAttribute('data-src') || elem.classList.contains('lazy')) {
                observer.unobserve(elem);
                return this.loadElement(elem);
            }

            // remove element from observer
            observer.unobserve(elem);
            return Promise.resolve(elem);
        }, this);

        Promise.all(entitiesPrms).then(this.reviseDependentComponents);
    }
    LazyLoad.prototype.reviseDependentComponents = function reviseDependentComponents(loadedElArr) {
        // if loaded elem is in carousel, slider, flexbox, resource card, tabset, tabsetaccordion
        // then refresh matchHeight so that it accounts for newly loaded elements

        var updateHeights = new Promise(function (resolve) {
            if (loadedElArr == null || loadedElArr.length <= 0) resolve();

            for (var index = 0; index < loadedElArr.length; index++) {
                var elem = loadedElArr[index];
                // we can expect null in the promise result. It could happen if parent logic skipped an element.
                if (!elem) continue;

                // find parent of newly loaded element and check if it needs to update matchHeight as a result
                // most of the time the binding does not refreshed, just a general update of existing bindings
                var resourceCard = elem.closest(".sage-resource-listing-results[data-ux-module]");
                if (resourceCard !== null) {
                    SageMatchHeight.prototype.applyBinding($(resourceCard.querySelectorAll('.sage-resources-card')), true, { byRow: true });
                    SageMatchHeight.prototype.applyBinding($(resourceCard.querySelectorAll('.sage-resources-card-content')), true, { byRow: true });
                }

                var carouselParent = elem.closest(".score-carousel");
                if (carouselParent !== null) {
                    SageMatchHeight.prototype.carouselBindings($(carouselParent), true);
                }

                var sliderParent = elem.closest(".score-slick-slider");
                if (sliderParent !== null) {
                    SageMatchHeight.prototype.findHighlightsAndApply($(sliderParent), true);
                    SageMatchHeight.prototype.applyBinding($(sliderParent).find(".score-slick-slider-panel"), true, { byRow: true });
                }


                var slickFlexboxParent = $(elem).parents(".score-flex-box.slick-contents");
                if (slickFlexboxParent !== null && slickFlexboxParent.length > 0) {
                    // set up match heighting on images now they have all loaded
                    SageMatchHeight.prototype.applyBinding($(slickFlexboxParent).find('img.img-responsive, svg.responsive-svg'). true);
                    SageMatchHeight.prototype.applyBinding($(slickFlexboxParent).find('.flex-item'), true, { byRow: true });
                }

                var verticalTabParent = $(elem).parents(
                        ".score-tab.vertical-tabset .tabAccordion-tabSet .tab-pane:not(.score-tab.sage-tab-outer .tab-pane):not(.score-tab.sage-tab-inner .tab-pane)");
                if (verticalTabParent !== null && verticalTabParent !== undefined && verticalTabParent.length > 0) {
                    //Remove existing height set on parent then reapply matchHeight
                    verticalTabParent.css("height", "auto");
                    SageMatchHeight.prototype.applyBinding(verticalTabParent, true);
                }

                var verticalTabAccordionParent = $(elem).parents(".score-tab.vertical-tabAccordion");
                if (verticalTabParent !== null && verticalTabParent !== undefined && verticalTabParent.length > 0) {
                    SageMatchHeight.prototype.findHighlightsAndApply($(verticalTabAccordionParent), true);
                    SageMatchHeight.prototype.applyBinding($(verticalTabAccordionParent).find(".tab-content-wrapper-outer.tabAccordion-tabSet .tab-pane:not(.sage-tab-home .tab-content-wrapper-outer.tabAccordion-tabSet .tab-pane)"), true);
                }

                
                SageMatchHeight.prototype.updateAllHeights();
            }

            resolve();
        });
        return Promise.resolve(updateHeights);

        
    }

    LazyLoad.prototype.loadElement = function loadElement(elem) {
        if (elem == null) {
            return Promise.resolve(null);
        }

        if (elem.tagName === 'IMG' || elem.tagName === 'img') {
            return this.loadImage(elem);
        }

        if (elem.tagName === 'IFRAME' || elem.tagName === 'iframe') {
            return this.loadIFrame(elem);
        }

        if (elem.getAttribute('data-lazy-evt') === 'true') {
            return this.callLoadEvent(elem).then(this.loadElement(elem));
        }

        if ((elem.tagName === 'DIV' || elem.tagName === 'div') & elem.getAttribute('data-src') == null ||
            (elem.tagName === 'SPAN' || elem.tagName === 'span') & elem.getAttribute('data-src') == null) {
            return this.loadBackgroundImage(elem);
        }

        // remove LazyLoad marker from the element
        elem.classList.remove('lazy');

        if (elem.classList.contains('article-collection')) {
            $('body:not(.animations-off) .article-collection .slick-slide').attr("animate-processed", true);
            $('body:not(.animations-off) .article-collection .slick-slide').addClass("lazy-animated--finished");
        }

        if (elem.getAttribute('data-lazy-evt') === 'false') {
            //lazy event was called, then function re-entered, so don't throw error
            return Promise.resolve(null);
        }

        console && console.error("LazyLoad unsupported HTMLElement. Reach out to a developer to provide a proper way to load an element", elem);
        // return unsupported state state
        return Promise.reject();
    }

    function isInViewport(elem) {
        const rect = elem.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    LazyLoad.prototype.callLoadEvent = function callLoadEvent(elem) {
        return new Promise(function (resolve, reject) {
            elem.classList.remove('lazy');
            elem.setAttribute("data-lazy-evt", false);
            var srcChangedEvent = new CustomEvent('lazy-load-evt');
            elem.dispatchEvent(srcChangedEvent);
            resolve(elem);
        });
    }

    LazyLoad.prototype.loadImage = function loadImage(elem) {
        var self = this;
        return new Promise(function (resolve, reject) {
            elem.addEventListener('load', function (e) { resolve(e.target); });
            elem.addEventListener('error', reject);

            // find any data-src and switch it to src
            elem.src = elem.getAttribute('data-src');
            elem.removeAttribute('width');
            elem.removeAttribute('height');

            if (elem.complete) {
                // loaded from cache
                resolve(elem);
            }

            // remove LazyLoad marker from the element
            elem.classList.remove('lazy');
            SageMatchHeight.prototype.updateAllHeights();
        }).then(function (elem) {
            var srcChangedEvent = new CustomEvent('lazy-src-changed');
            elem.dispatchEvent(srcChangedEvent);

            return elem;
        });
    }

    LazyLoad.prototype.loadIFrame = function loadIFrame(elem) {
        return new Promise(function (resolve, reject) {
            elem.classList.remove('lazy');
            elem.src = elem.getAttribute('data-src');
            resolve(elem);
        });
    }

    LazyLoad.prototype.loadBackgroundImage = function loadBackgroundImage(elem) {
        return new Promise(function (resolve, reject) {
            elem.classList.remove('lazy');
            resolve(elem);
        });
    }

    LazyLoad.prototype.getUrlExtension = function getUrlExtension(url) {
        return url.split(/[#?]/)[0].split('.').pop().trim();
    }

    LazyLoad.prototype.animationCallback = function (entities, observer) {
        var groupedElements = {};

        var entitiesPrms = entities.map(function (intersectionEntity) {
            if (!intersectionEntity.isIntersecting) return Promise.resolve(null);

            var elem = intersectionEntity.target;
            if (!$(elem).attr("animate-processed")) {
                $(elem).attr("animate-processed", true);
                //get elements
                //group them by parent to know what "group" they are in
                //each group needs to start at the same time
                //each entry in the group needs to be delayed by 200ms extra
                var parentId = elem.parentElement.id;
                if (!groupedElements[parentId]) {
                    groupedElements[parentId] = [];
                }
                groupedElements[parentId].push(elem);
            }

            observer.unobserve(elem);
            return Promise.resolve(elem);
        }, this);

        var keys = Object.keys(groupedElements);
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            var arr = groupedElements[key];
            arr.forEach(function (elem, index) {
                window.setTimeout(function () {
                    $(elem).addClass("lazy-animated--finished");

                    if ($(elem).hasClass("to-animate")) {
                        window.setTimeout(function () {
                            $(elem).removeClass("to-animate");
                        }, (400));
                    }
                }, (index * 200));
            });
        }

        Promise.all(entitiesPrms);
    }

    // static func
    LazyLoad.init = function init() {
        return new LazyLoad();
    }

    return LazyLoad;
});

